import { createSlice } from '@reduxjs/toolkit';

import type { EscritorioMembrosState } from '@/types/escritorio/escritorioTypes';

import {
  atualizarPapelMembroDoTenant,
  listarMembrosDoTenant,
  removerMembroDoTenant,
} from './actions';

const initialState: EscritorioMembrosState = {
  membros: [],
  isLoading: false,
  error: null,
  loadedEscritorioId: null,
};

const membrosTenantSlice = createSlice({
  name: 'membrosTenant',
  initialState,
  reducers: {
    limparMembrosDoTenant: (state) => {
      state.membros = [];
      state.loadedEscritorioId = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarMembrosDoTenant.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarMembrosDoTenant.fulfilled, (state, action) => {
        state.isLoading = false;
        state.membros = action.payload;
        state.loadedEscritorioId = action.meta.arg.escritorioId;
      })
      .addCase(listarMembrosDoTenant.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? 'Erro ao listar membros do escritório';
        state.loadedEscritorioId = action.meta.arg.escritorioId;
      })

      .addCase(atualizarPapelMembroDoTenant.fulfilled, (state, action) => {
        state.membros = state.membros.map((membro) =>
          membro.id === action.meta.arg.membroId
            ? { ...membro, papel: action.meta.arg.papel }
            : membro,
        );
      })
      .addCase(atualizarPapelMembroDoTenant.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao atualizar o papel do membro';
      })

      .addCase(removerMembroDoTenant.fulfilled, (state, action) => {
        state.membros = state.membros.filter((membro) => membro.id !== action.meta.arg.membroId);
      })
      .addCase(removerMembroDoTenant.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao remover o membro do escritório';
      });
  },
});

export const { limparMembrosDoTenant } = membrosTenantSlice.actions;
export const membrosTenantReducer = membrosTenantSlice.reducer;
